export const VUE_APP_EDGE_SERVER = 'VUE_APP_EDGE_SERVER';
export const VUE_APP_LOCALHOST_OVERRIDE = 'VUE_APP_LOCALHOST_OVERRIDE';
export const VUE_APP_ACCOUNT_LOGIN_PAGE_WITH_REDIRECT = 'VUE_APP_ACCOUNT_LOGIN_PAGE_WITH_REDIRECT';
export const VUE_APP_ACCOUNT_TOKEN_PAGE = 'VUE_APP_ACCOUNT_TOKEN_PAGE';
export const VUE_APP_LANDING_PAGE = 'VUE_APP_LANDING_PAGE';
export const VUE_APP_SUPPORT_PAGE = 'VUE_APP_SUPPORT_PAGE';
export const VUE_APP_APP_SNAPSHOT = 'VUE_APP_APP_SNAPSHOT';
export const VUE_APP_STRIPE_ID = 'VUE_APP_STRIPE_ID';

export const VUE_IS_BETA = 'VUE_IS_BETA';
export const VUE_IS_TEST = 'VUE_IS_TEST';

export function getEnv(name) {
  return window?.configs?.[name] || process.env[name];
}
